// ──────────────────────────────────────────────────
//  Roebling Landing-Page Scripts
//  Brooklyn Bicycle Co. | 2025 | v2.1
// ──────────────────────────────────────────────────

// ---- COMMUTE CALCULATOR ----
function roeblingCalcUpdate() {
  var mode = document.getElementById("rlp-commute-mode");
  var distance = document.getElementById("rlp-commute-distance");
  var time = document.getElementById("rlp-commute-time");
  var daysEl = document.getElementById("rlp-commute-days");
  if (!mode || !distance || !time) return;
  var dist = parseFloat(distance.value) || 0;
  var mins = parseFloat(time.value) || 0;
  var daysPerWeek = parseInt(daysEl ? daysEl.value : "5") || 5;
  if (dist <= 0 || mins <= 0) return;

  var WEEKS_PER_YEAR = 50;
  var BIKE_MPH = 12;
  var commuteDays = daysPerWeek * WEEKS_PER_YEAR;

  // Annual flat costs scaled by days/week (base = 5 days)
  var flatAnnual = { bus: 600, subway: 1518 };
  // Per-mile costs (round-trip: dist * rate * 2 * commuteDays)
  var costPerMile = { driving: 0.655, rideshare: 2.10 };

  var modeLabels = {
    subway: "Subway", bus: "Bus", rideshare: "Rideshare",
    driving: "Driving", mixed: "Mixed Transit"
  };
  var altModeMap = {
    subway: "driving", bus: "driving", rideshare: "driving",
    driving: "rideshare", mixed: "driving"
  };

  function yearCost(m, d, dpw) {
    if (flatAnnual[m]) return Math.round(flatAnnual[m] * (dpw / 5));
    if (costPerMile[m]) return Math.round(dist * costPerMile[m] * 2 * d);
    if (m === "mixed") return Math.round((flatAnnual.bus * (dpw / 5) * 0.6) + (dist * 2.10 * 2 * d * 0.4));
    return 0;
  }

  var yearlyCostCurrent = yearCost(mode.value, commuteDays, daysPerWeek);

  var altKey = altModeMap[mode.value] || "driving";
  var altYearlyCost = yearCost(altKey, commuteDays, daysPerWeek);

  var altSpeedRatio = { subway: 0.9, bus: 0.7, rideshare: 1.1, driving: 1.0, mixed: 0.85 };
  var curSpeedFactor = altSpeedRatio[mode.value] || 1.0;
  var altSpeedFactor = altSpeedRatio[altKey] || 1.0;
  var altMins = Math.round(mins * (curSpeedFactor / altSpeedFactor));

  var bikeOneWay = Math.round(dist / BIKE_MPH * 60);

  var timeDiffPerDayMins = (mins - bikeOneWay) * 2;
  var yearlyTimeDiffHours = Math.round(Math.abs(timeDiffPerDayMins) * commuteDays / 60);

  var set = function(id, txt) {
    var el = document.getElementById(id);
    if (el) el.textContent = txt;
  };

  set("rlp-result-current-label", modeLabels[mode.value] || "Current");
  set("rlp-result-current-time", mins + " min each way");
  set("rlp-result-current-cost", "$" + yearlyCostCurrent.toLocaleString() + "/year");

  set("rlp-result-alt-label", modeLabels[altKey] || "Driving");
  set("rlp-result-alt-time", altMins + " min each way");
  set("rlp-result-alt-cost", "$" + altYearlyCost.toLocaleString() + "/year");

  set("rlp-result-bike-time", bikeOneWay + " min each way");
  set("rlp-result-bike-cost", "$0/year");

  set("rlp-savings-amount", "$" + yearlyCostCurrent.toLocaleString());

  if (timeDiffPerDayMins >= 0) {
    set("rlp-savings-hours", yearlyTimeDiffHours + " hours/year back in your life");
  } else {
    set("rlp-savings-hours", yearlyTimeDiffHours + " hours/year invested in fitness and fresh air");
  }

  var results = document.querySelector(".rlp-calc__results");
  if (results) { results.style.display = "block"; }
  if (results) { results.scrollIntoView({ behavior: "smooth", block: "start" }); }
}

// ---- SIZE QUIZ (step-based wizard) ----
// Size chart (matches /pages/roebling-chart and the sticky bar size guide):
// 15 / XS = 4'11" - 5'2"
// 17 / S  = 5'3" - 5'6"
// 19 / M  = 5'7" - 5'10"
// 21 / L  = 5'11" - 6'1"
// 23 / XL = 6'2" - 6'4"
//
// 2026-08-21 ruling: M used to run to 5'11" and L started at 6'0", which put
// 5'11" riders on the M. Support had been answering 5'11" as L for months.
// M now ends at 5'10", L starts at 5'11". Mirrored in the section buttons, the
// sticky bar size guide, the published chart page, and the variant labels.
var _roeblingQuizAnswers = {};

function roeblingSelectQuiz(step, value) {
  _roeblingQuizAnswers[step] = value;

  // Highlight selected option
  var stepEl = document.getElementById('rlp-quiz-step-' + step);
  if (stepEl) {
    var opts = stepEl.querySelectorAll('.rlp-quiz__option');
    for (var i = 0; i < opts.length; i++) { opts[i].classList.remove('selected'); }
    for (var j = 0; j < opts.length; j++) {
      var onclick = opts[j].getAttribute('onclick') || '';
      if (onclick.indexOf("'" + value + "'") !== -1) { opts[j].classList.add('selected'); break; }
    }
  }

  // Advance to next step or show result
  if (step < 3) {
    var currentStep = document.getElementById('rlp-quiz-step-' + step);
    var nextStep = document.getElementById('rlp-quiz-step-' + (step + 1));
    if (currentStep) currentStep.classList.remove('active');
    if (nextStep) { nextStep.classList.add('active'); nextStep.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  } else {
    roeblingQuizResult();
  }
}

function roeblingQuizBack(currentStep) {
  var cur = document.getElementById('rlp-quiz-step-' + currentStep);
  var prev = document.getElementById('rlp-quiz-step-' + (currentStep - 1));
  if (cur) cur.classList.remove('active');
  if (prev) { prev.classList.add('active'); prev.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
}

function roeblingQuizRestart() {
  _roeblingQuizAnswers = {};
  // Hide result
  var resultEl = document.getElementById('rlp-quiz-result');
  if (resultEl) resultEl.classList.remove('active');
  // Clear all selected states
  var allOpts = document.querySelectorAll('.rlp-quiz__option');
  for (var i = 0; i < allOpts.length; i++) { allOpts[i].classList.remove('selected'); }
  // Hide all steps, show step 1
  for (var s = 1; s <= 3; s++) {
    var stepEl = document.getElementById('rlp-quiz-step-' + s);
    if (stepEl) stepEl.classList.remove('active');
  }
  var step1 = document.getElementById('rlp-quiz-step-1');
  if (step1) { step1.classList.add('active'); step1.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
}

function roeblingQuizResult() {
  var height = _roeblingQuizAnswers[1] || '';
  var build = _roeblingQuizAnswers[2] || 'average';

  // Variant IDs keyed by frame size (matches sticky bar _srbQuizVariantMap)
  var variantMap = {
    '15': '39340591677520',
    '17': '39340591710288',
    '19': '39340591743056',
    '21': '39340591775824',
    '23': '39340591939664'
  };

  // Maps match the sticky bar size guide exactly
  var sizeMap = {
    'xs': { frame: '15', code: 'XS', full: 'X-Small', desc: 'The 15" frame fits riders 4\'11" to 5\'2". Low standover, confident handling in the city.' },
    'sm': { frame: '17', code: 'S',  full: 'Small',   desc: 'The 17" frame is built for riders 5\'3" to 5\'6". Nimble and efficient.' },
    'md': { frame: '19', code: 'M',  full: 'Medium',  desc: 'Our most popular size. The 19" frame fits riders 5\'7" to 5\'10". Great all-around fit.' },
    'lg': { frame: '21', code: 'L',  full: 'Large',   desc: 'The 21" frame fits riders 5\'11" to 6\'1". Full leg extension, stable at speed.' },
    'xl': { frame: '23', code: 'XL', full: 'X-Large', desc: 'The 23" frame fits riders 6\'2" to 6\'4". Maximum reach and standover clearance.' }
  };

  // Build does NOT affect frame size (Ryan, 2026-08-22). Frame size is set by
  // height and inseam. Build shows up in saddle height, stem, and bar reach,
  // which the partner shop dials in at assembly.
  //
  // This used to bump every rider who answered "Broad / stocky" up a full frame
  // size. That contradicted the published chart, the size finder, the PDP size
  // tooltip, and the sticky bar size guide, and at the ends of the range it was
  // actively wrong: a 4'11" rider was sent to a 17"/S specced for 5'3" to 5'6",
  // and after the 2026-08-21 M/L ruling a 5'11" rider was sent to a 23"/XL
  // specced for 6'2" to 6'4". Height alone now decides the size.
  //
  // The answer is still captured and sent to dataLayer as quiz_build below, so
  // the segmentation value of the question is preserved.

  var result = sizeMap[height] || sizeMap['md'];

  // Hide all steps, show result
  for (var s = 1; s <= 3; s++) {
    var stepEl = document.getElementById('rlp-quiz-step-' + s);
    if (stepEl) stepEl.classList.remove('active');
  }

  var resultEl = document.getElementById('rlp-quiz-result');
  var badgeEl = document.getElementById('rlp-quiz-size');
  var textEl = document.getElementById('rlp-quiz-size-text');
  var descEl = document.getElementById('rlp-quiz-size-desc');
  var ctaEl = document.getElementById('rlp-quiz-size-cta');

  // Badge shows frame size (e.g. "19") so sticky bar variant sync works
  if (badgeEl) badgeEl.textContent = result.frame;
  if (textEl) textEl.textContent = result.full + ' (' + result.frame + '")';
  if (descEl) descEl.textContent = result.desc;
  if (ctaEl) ctaEl.textContent = result.code;

  // Set CTA link to exact variant on the PDP
  var ctaLink = document.querySelector('#rlp-quiz-result a.btn-primary');
  if (ctaLink && variantMap[result.frame]) {
    ctaLink.href = '/products/roebling?variant=' + variantMap[result.frame];
  }

  if (resultEl) { resultEl.classList.add('active'); resultEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); }

  if (typeof dataLayer !== 'undefined') {
    dataLayer.push({
      event: 'roebling_size_quiz',
      quiz_height: _roeblingQuizAnswers[1] || '',
      quiz_build: build,
      quiz_ride: _roeblingQuizAnswers[3] || '',
      quiz_result: result.frame + '" / ' + result.code
    });
  }
}

// ---- CALCULATOR EMAIL CAPTURE ----
function roeblingCaptureEmail() {
  var email = document.getElementById('rlp-capture-email').value;
  if (!email || !email.includes('@')) {
    alert('Enter a valid email.');
    return;
  }

  var KLAVIYO_LIST_ID = 'XVU7nN';

  var mode = document.getElementById('rlp-commute-mode').value;
  var distance = document.getElementById('rlp-commute-distance').value;
  var savings = document.getElementById('rlp-savings-amount').textContent;

  var payload = {
    data: {
      type: 'subscription',
      attributes: {
        custom_source: 'Roebling Commute Calculator',
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: email,
              properties: {
                'Commute Mode': mode,
                'Commute Distance (mi)': distance,
                'Estimated Annual Savings': savings,
                'Calculator Source': 'roebling-landing-page'
              }
            }
          }
        }
      },
      relationships: {
        list: {
          data: {
            type: 'list',
            id: KLAVIYO_LIST_ID
          }
        }
      }
    }
  };

  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=KUyM7F', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'revision': '2024-10-15'
    },
    body: JSON.stringify(payload)
  })
  .then(function() {
    document.getElementById('rlp-email-capture').style.display = 'none';
    document.getElementById('rlp-email-success').style.display = 'block';
    if (typeof dataLayer !== 'undefined') {
      dataLayer.push({ event: 'roebling_email_capture', commute_mode: mode, commute_distance: distance });
    }
  })
  .catch(function() {
    document.getElementById('rlp-email-capture').style.display = 'none';
    document.getElementById('rlp-email-success').style.display = 'block';
  });
}

// ---- FAQ ACCORDION ----
function roeblingFaqToggle(btn) {
  var item = btn.closest('.rlp-faq__item');
  if (!item) return;
  var isOpen = item.classList.contains('is-open');
  // close all in same section
  item.closest('.rlp-faq__list').querySelectorAll('.rlp-faq__item').forEach(function(el) {
    el.classList.remove('is-open');
  });
  if (!isOpen) item.classList.add('is-open');
}

// ---- TESTIMONIAL CAROUSEL ----
(function() {
  var track, dots, cards, idx = 0;
  function init() {
    track = document.querySelector('.rlp-proof__track');
    if (!track) return;
    cards = track.querySelectorAll('.rlp-proof__card');
    dots  = document.querySelectorAll('.rlp-proof__dot');
    if (cards.length < 2) return;
    document.querySelector('.rlp-proof__prev').addEventListener('click', function() { go(idx - 1); });
    document.querySelector('.rlp-proof__next').addEventListener('click', function() { go(idx + 1); });
    dots.forEach(function(d, i) { d.addEventListener('click', function() { go(i); }); });
  }
  function go(n) {
    idx = (n + cards.length) % cards.length;
    track.style.transform = 'translateX(-' + (idx * 100) + '%)';
    dots.forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();


// ---- SMOOTH SCROLL (CTA anchors) ----
function roeblingScrollTo(id) {
  document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'start' });
}


// ---- GUIDE CAPTURE (bottom of page, no calculator dependency) ----
function roeblingCaptureGuideEmail() {
  var email = document.getElementById('rlp-guide-email').value;
  if (!email || !email.includes('@')) {
    alert('Enter a valid email.');
    return;
  }

  var KLAVIYO_LIST_ID = window.ROEBLING_GUIDE_KLAVIYO_LIST_ID || 'XVU7nN';
  var KLAVIYO_SOURCE = window.ROEBLING_GUIDE_KLAVIYO_SOURCE || 'Roebling LP - Guide Capture';

  var payload = {
    data: {
      type: 'subscription',
      attributes: {
        custom_source: KLAVIYO_SOURCE,
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: email,
              properties: {
                'Calculator Source': 'roebling-landing-page',
                'Lead Type': 'guide-bottom-cta'
              }
            }
          }
        }
      },
      relationships: {
        list: {
          data: {
            type: 'list',
            id: KLAVIYO_LIST_ID
          }
        }
      }
    }
  };

  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=KUyM7F', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'revision': '2024-10-15'
    },
    body: JSON.stringify(payload)
  })
  .then(function() {
    document.getElementById('rlp-guide-email-capture').style.display = 'none';
    document.getElementById('rlp-guide-email-success').style.display = 'block';
    if (typeof dataLayer !== 'undefined') {
      dataLayer.push({ event: 'roebling_guide_capture', lead_type: 'guide-bottom-cta' });
    }
  })
  .catch(function() {
    document.getElementById('rlp-guide-email-capture').style.display = 'none';
    document.getElementById('rlp-guide-email-success').style.display = 'block';
  });
}

